module.exports = __webpack_public_path__ + "static/media/recording.bee97455.png";